const checkOnlineStatus = async (_url? : string) => {
  if (!window.navigator.onLine) return false;

  const url = _url ? _url : new URL(window.location.origin);

  try {
    const response = await fetch(
      url.toString(),
      {
        method: 'HEAD',
        cache: 'no-store'
      }
    );

    if(!response.ok) return false;

    return response.ok;
  } catch(_err) {
    return false;
  }
};

export default checkOnlineStatus;
